<div
    class="full-modal-config__section"
    provideParentForm
>
    <h3>{{ l10nKeys.sectionTitlePing | vtranslate }}</h3>

    <health-monitor-port-ip-group
        [editable]="editable"
        [hidePortInput]="true"
    ></health-monitor-port-ip-group>
</div>
